import { motion } from "framer-motion";

/**
 * Reveal — apparition subtile au scroll.
 * Petite translation verticale + fondu, déclenchés une seule fois lorsque le
 * bloc entre dans le viewport. Conserve le ton sobre du site.
 */
export default function Reveal({
  children,
  delay = 0,
  y = 14,
  duration = 0.7,
  className = "",
  as = "div",
}) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px 0px -60px 0px" }}
      transition={{ duration, delay, ease: [0.22, 0.61, 0.36, 1] }}
      className={className}
    >
      {children}
    </MotionTag>
  );
}
